import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
  browserPopupRedirectResolver,
  GoogleAuthProvider,
} from 'firebase/auth';

// Web config for the lezzoo-ad-manager Firebase project (same project the Ops
// dashboard uses). These are PUBLIC client values (they ship in every client
// bundle), so hardcoding is safe. Hardcoded because CRA inlines REACT_APP_* at
// BUILD time and the Docker builder stage doesn't receive them — env is still
// honored when present (dev / a fixed build), otherwise it falls back here.
// b2b-admin-app.lezzoodevs.com is an authorized domain in that project.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAm829ffBn8_f_MzYSe_kw_dWC9ziHrHss',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'lezzoo-ad-manager.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'lezzoo-ad-manager',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'lezzoo-ad-manager.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '993557861367',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:993557861367:web:77ed0fec8b8b7d6916d4f2',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-YZRFZTR5BJ',
};

const app = initializeApp(firebaseConfig);

// getAuth() defaults to IndexedDB persistence, which fails with
// "Database is closing/hidden" on some Chrome profiles and rejects sign-in.
// This ordered persistence list keeps the popup flow reliable.
const auth = initializeAuth(app, {
  persistence: [
    browserLocalPersistence,
    browserSessionPersistence,
    inMemoryPersistence,
  ],
  popupRedirectResolver: browserPopupRedirectResolver,
});

const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
